import {useState} from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import { DialogMessage } from "../../../global/DialogMessage";
import BackDrop from "../../../global/BackDrop";
import { eliminarCiudadPaqueteTerrrestre, obtenerCiudadesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 250,
  },
})
const TablaRegistro = (props) => {

  const { listaCiudadesTerrestre, paqueteSelect } = useSelector((state) => state.proveedorTerrestre);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isLoad, setIsLoad] = useState(false);

  const onDelete = async (destino) => {
    const result = await DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminarlo',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    });
  
    if (result.isConfirmed) {
      setIsLoad(true);
      try {
        // Eliminar destino
        const response = await dispatch(eliminarCiudadPaqueteTerrrestre({
          idPaqueteTerrestreCiudad: destino.IdPaqueteProveedorTerrestreCiudad,
        }));
        
        if (response?.status === 200) {
          ToastMessage.fire('¡Eliminado!', 'El destino ha sido eliminado.', 'success');
        }
  
        // Obtener lista actualizada
        await dispatch(obtenerCiudadesPaqueteTerrestre({
          idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
        }));
      } catch (error) {
        ToastMessage.fire('Error', 'No se pudo eliminar el destino.', 'error');
      } finally {
        setIsLoad(false);
      }
    } else {
      ToastMessage.fire('Cancelado', 'No se ha realizado ningún cambio.', 'info');
    }
  };
  
  return (
    <div>
      <TableContainer component={Paper} className={classes.container}>
        <Table size="small" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Destino</TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listaCiudadesTerrestre.map((destino) => (
              <TableRow key={destino.IdPaqueteProveedorTerrestreCiudad}>
                <TableCell align="left">{`${destino.Ciudad?.Nombre} - ${destino.Ciudad?.Pais?.Nombre}`}</TableCell>
                <TableCell align="center">
                  <ButtonGroup
                    color="primary"
                    size="small"
                    aria-label="small outlined  button group"
                  >
                    <Button onClick={() =>onDelete(destino)}>Eliminar</Button>
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <BackDrop open={isLoad}/>
    </div>
  );
};
export default TablaRegistro;
